var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpGray = function SvgHelpGray(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15D300E9-2E17-4DB8-A449-8797778E89D3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "#d8d8d8",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-/-error-white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-help-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 24 0 24 24 0 24",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C7.032,3 3,7.032 3,12 C3,16.968 7.032,21 12,21 C16.968,21 21,16.968 21,12 C21,7.032 16.968,3 12,3 Z M12,17.4 L12,17.4 C11.5029437,17.4 11.1,16.9970563 11.1,16.5 L11.1,11.1 C11.1,10.6029437 11.5029437,10.2 12,10.2 L12,10.2 C12.4970563,10.2 12.9,10.6029437 12.9,11.1 L12.9,16.5 C12.9,16.9970563 12.4970563,17.4 12,17.4 Z M12,8.4 L12,8.4 C11.5029437,8.4 11.1,7.99705627 11.1,7.5 L11.1,7.5 C11.1,7.00294373 11.5029437,6.6 12,6.6 L12,6.6 C12.4970563,6.6 12.9,7.00294373 12.9,7.5 L12.9,7.5 C12.9,7.99705627 12.4970563,8.4 12,8.4 Z",
    id: "Shape",
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help-gray.58f4593660df21b3358a5478303fd706.svg";